import i18n from 'i18next'
import trans from '../translations/index'
import CONSTANTS from './constants/index'

const namespaces = ['common']
if (CONSTANTS.SITE !== null) {
  namespaces.push(CONSTANTS.SITE)
}

i18n
  .init({
    whitelist: Object.keys(trans),
    lng: CONSTANTS.LOCALE,
    fallbackLng: 'en-GB',
    // have a common namespace used around the full app
    ns: namespaces,
    load: 'currentOnly',
    defaultNS: 'common',
    fallbackNS: 'common',
    resources: trans,
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },
  })

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js